module.exports = __webpack_public_path__ + "img/2.345c5e33.jpg";